module.exports = __webpack_public_path__ + "img/lvshiyuyue.fd199b8f.png";